<template>
    <cadastro-simples-form
        endpoint="criterio-avaliacao"
        rota-base="/admin/criterio-avaliacao"
        titulo-singular="Critério de Avaliação"
        :campos-extras='[{"campo":"competencia","label":"Competência","tipo":"string"},{"campo":"curso_id","label":"Curso/Etapa","tipo":"select","optionsEndpoint":"curso/getAllCurso","optionValue":"id","optionLabel":"nome","placeholder":"Todos os cursos (deixe vazio para global)"},{"campo":"peso","label":"Peso","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
